export default "__VITE_PUBLIC_ASSET__df00485d__"